import React from 'react'
import {
  IonContent
} from '@ionic/react'
import { Advertisement } from '../../../components/common/Advertisement'
import EmbedFrame from '../../../components/content/EmbedFrame'
import './styles.scss'

const Live = (props) => {
  const { resource } = props

  return (
    <IonContent
      fullscreen
      className='live page-wrapper'
    >
      <div className='flexible-width-content'>
        <Advertisement />
        <h1>
          {resource.public_name}
        </h1>
        <EmbedFrame embed={{ type: resource.embed, src: resource.src }} />
        <Advertisement />
      </div>
    </IonContent>
  )
}

export default Live
